<template>
  <div :id="content.idHTML" class="pannel-body px-2 py-2">
    <ValidationObserver ref="observer" v-slot="{ invalid }" :vid="'vobserver' + uniqueId" tag="div">
      <b-form :id="'idFormulaire' + uniqueId" @submit.stop.prevent="onSubmit($event)">
        <div v-show="isErreurServeur">
          <MessageMel
            v-show="contentMessageMel.message"
            :content="contentMessageMel.message"
            class="mt-n1 mt-md-0 mb-1 mx-0 mx-md-auto pl-0"
          ></MessageMel>
        </div>
        <Paragraphe
          :content="{
            richText: content.libNouvelleLimite,
            classeCSS: 'pt-1',
          }"
          class="titre-legal"
        ></Paragraphe>
        <GroupeRadio
          v-model="choix"
          :content="contentGroupeRadio"
          @input="setLimitValue"
        ></GroupeRadio>
        <div class="btn-rigth">
          <b-button
            type="submit"
            variant="tertiaire"
            class="btn btn-primaire-limite px-6 mb-0"
            :disabled="invalid || isSubmitted"
          >
            <div class="">
              <div v-if="isSubmitted" class="mr-1">
                <b-spinner small :label="$t('chargement')"></b-spinner>
              </div>
              <span class="">{{ content.libBtnConfirmer }}</span>
            </div>
          </b-button>
        </div>
        <Paragraphe
          v-if="category !== 'deposit'"
          :content="{
            richText: getContentTxtDelais,
            classeCSS: 'pt-1',
          }"
          class="texte-legal"
        ></Paragraphe>
      </b-form>
    </ValidationObserver>
  </div>
</template>

<script>
// LQ
import VMoney from 'v-money';
import GroupeRadio from '@/components/formulaire/base/GroupeRadio';
import MessageHelpers from '@/helpers/MessageHelpers';
import MessageMel from '@/components/base/MessageMel';
import encadrerJeux from '@/services/api/compte/encadrerJeux';
import Paragraphe from '@/components/base/Paragraphe';
import { formatMontant } from '@/helpers/StringHelpers';

export default {
  name: 'LimitForm',

  components: {
    GroupeRadio,
    MessageMel,
    Paragraphe,
  },
  directives: { money: VMoney },
  props: {
    category: String,
    period: String,
    initialValue: { type: String, default: null },
    content: { type: Object, required: false },
  },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          day: 'quotidienne',
          week: 'hebdomadaire',
          month: 'mensuel',
        },
      },
      en: {
        messageComponent: {
          day: 'daily',
          week: 'weekly',
          month: 'monthly',
        },
      },
    },
  },
  data() {
    return {
      choix: this.initialValue || null,
      otherValue: null,
      isSubmitted: false,
      isAlerteExist: false,
      isErreurServeur: false,
      uniqueId: this.uid,
      contentMessageMel: {
        message: {},
      },
      minMax: {
        maxTimeDay: 1 * 24,
        maxTimeWeek: 7 * 24,
        maxTimeMonth: 31 * 24,
        maxLoss: 999999,
      },
    };
  },
  computed: {
    labelPeriod() {
      return this.period.charAt(0).toUpperCase() + this.period.slice(1);
    },
    getContentTxtDelais() {
      return this.content[`txtDelais${this.labelPeriod}`];
    },
    unite() {
      return this.category === 'time' ? 'h' : '$';
    },
    getInputLength() {
      const lengthMap = { time: 3, loss: 7 };
      return lengthMap[this.category] || 4;
    },
    // Construction des valeurs d'encrage pour les limites
    getOptionsLimit() {
      let idx = 0;
      if (this.category == 'deposit') {
        // cas d'exception
        idx = 0;
      } else if (this.period === 'week') {
        idx = 1;
      } else if (this.period === 'month') {
        idx = 2;
      }
      const nodeKey = this.content[this.category]['@nodes'][idx];
      const nodeData = this.content[this.category][nodeKey];

      const unArray = [];
      unArray.push(
        { text: this.getTextLocalised(nodeData.limit1), value: nodeData.limit1 }, // `${nodeData.limit1} ${this.unite}`
        { text: this.getTextLocalised(nodeData.limit2), value: nodeData.limit2 }
      );
      // cas d’exception
      const casException = this.category === 'time' && this.period === 'day';
      if (!casException) {
        unArray.push({ text: this.getTextLocalised(nodeData.limit3), value: nodeData.limit3 });
      }
      unArray.push({ text: this.content.libAutreLimite, value: 0 });
      return unArray;
    },

    // Affichage info sous input GroupRadio
    getMinMaxValueValidationAutre() {
      let min = process.env.VUE_APP_MIN_LIMITE_DEPOT_HEBDO;
      let max = process.env.VUE_APP_MAX_LIMITE_DEPOT_HEBDO;
      let validationMsg = '';

      if (this.category === 'deposit') {
        validationMsg = this.$i18n.t('validations.messages.encadrerJeux.limiteDepotInvalide', {
          min: formatMontant(min),
          max: formatMontant(max),
        });
      } else if (this.category === 'time') {
        min = 1;
        if (this.period === 'day') {
          max = this.minMax.maxTimeDay;
        } else if (this.period === 'week') {
          max = this.minMax.maxTimeWeek;
        } else if (this.period === 'month') {
          max = this.minMax.maxTimeMonth;
        }
      } else {
        min = 1;
        max = this.minMax.maxLoss;
      }
      return { min, max, validationMsg };
    },

    contentGroupeRadio() {
      return {
        format: 'tableau',
        optionsInfo: this.getOptionsLimit,
        type: 'number',
        minMaxValues: this.getMinMaxValueValidationAutre,
        validationAutre:
          this.category === 'time'
            ? `is_limite_temps_bienJouer_valid:${this.getMinMaxValueValidationAutre.max}`
            : `is_limite_depot_bienJouer_valid:${this.getMinMaxValueValidationAutre.min},${this.getMinMaxValueValidationAutre.max}`,
        libAutre: '',
        unite: this.category === 'time' ? 'h' : '$',
        inputLength: this.getInputLength,
      };
    },
  },

  methods: {
    onSubmit() {
      if (this.isSubmitted) {
        return;
      }
      this.isSubmitted = true;
      encadrerJeux
        .setLimiteJeux({ category: this.category, period: this.period, value: this.choix })
        .then((response) => {
          this.isSubmitted = false;
          console.log('response : ', response);
          this.isErreurServeur = false;
          this.$emit('success-limitSet');
        })
        .catch((error) => {
          // TODO gestion erreur
          console.error('Erreur de récupération des données!', error);
          this.gererMessageErreur(error);
          this.isSubmitted = false;
        });
    },

    async affichageMessageErreur(code, type) {
      this.contentMessageMel[type] = await this.recupererMessage(code);
      this.isErreurServeur = true;
    },

    setLimitValue(value) {
      this.choix = value;
      console.log(`input = ${this.choix}`);
    },

    getTextLocalised(value) {
      if (this.category === 'time') {
        return `${value} ${this.unite}`;
      }
      return formatMontant(value);
    },

    // TODO mettre cette fonction dans le helper
    recupererMessage(codeMessage, keysValueRemplacement = {}) {
      return new Promise((resolve, reject) => {
        MessageHelpers.obtenirMessage(codeMessage, this.$root)
          .then((msgResp) => {
            let messageTraiter = msgResp.msgDetail;
            if (keysValueRemplacement) {
              Object.entries(keysValueRemplacement).forEach(([cle, valeur]) => {
                const regex = new RegExp(`\\{{${cle}\\}}`, 'g');
                messageTraiter = messageTraiter.replace(regex, valeur);
              });
            }
            resolve({
              titre: msgResp.msgTitre,
              message: messageTraiter,
              msgType: msgResp.msgType,
            });
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    async gererMessageErreur(error) {
      const errorCause = error?.response?.data?.detailCause;
      if (['LIMIT_INCREASE_QUEUED', 'MAX_INCREASE_LIMIT'].includes(errorCause)) {
        this.affichageMessageErreur(`MSG05-6-09-${this.category}`, 'message'); // x 3
      } else if (errorCause === 'DAY_GREATER_WEEK') {
        this.affichageMessageErreur('MSG05-6-10', 'message');
      } else if (errorCause === 'WEEK_GREATER_MONTH') {
        this.affichageMessageErreur('MSG05-6-11', 'message');
      } else if (errorCause === 'DAY_GREATER_MONTH') {
        this.affichageMessageErreur('MSG05-6-12', 'message');
      } else {
        this.affichageMessageErreur('MSG01', 'message');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.pannel-body {
  background-color: $couleur-bg-form-bien-jouer;
}

.btn-primaire-limite {
  display: flex !important;
  height: 3rem;
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  align-self: stretch;
  border-radius: 2.5rem !important;
  background: $couleur-btn-bien-jouer;
  color: $couleur-noir !important;

  &.disabled,
  &:disabled {
    opacity: 50%;
    background: $couleur-btn-inactif-bien-jouer;
    border: 1px solid #ccc;
    cursor: not-allowed;
  }

  &:not(.disabled):not(:disabled):active,
  &:not(.disabled):not(:disabled):focus,
  &:not(.disabled):not(:disabled):hover {
    background: $couleur-btn-hover-bien-jouer;
  }
}
.texte-legal {
  font-size: 14px;
}

.btn-rigth {
  display: flex;
  justify-content: center;
  margin: 1rem 0 1rem;

  .btn {
    width: 100%; /* 100% de largeur sur mobile */
  }
}

@media (min-width: 768px) {
  .btn-rigth {
    justify-content: flex-end; /* Aligné à droite */

    .btn {
      width: 50%; /* 100% de largeur sur mobile */
    }
  }
}
</style>
